import { makeStyles } from '@material-ui/core';
import theme from '../../theme/booking-theme';

// eslint-disable-next-line import/prefer-default-export
export const countdownClockStyles = makeStyles({
  root: {
    zIndex: 1,
    borderRadius: 5,
    color: (props) => theme.palette[props.color],
    padding: '8px 16px',
    textTransform: 'none',

    '& .title': {
      paddingRight: 16,
      fontFamily: theme.typography.proxima.bold,
      fontSize: theme.typography.pxToRem(12),
      [theme.breakpoints.up('lg')]: {
        paddingRight: 24,
      },
      [theme.breakpoints.up('xl')]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },

    '& .countDownContainer': {
      alignItems: 'center',
      color: (props) => theme.palette[props.color],
      justifyContent: 'center',
      letterSpacing: theme.typography.pxToRem(0),
      textAlign: 'center',
      '& .timeUnit': {
        alignItems: 'center',
        display: 'flex',
        paddingRight: 8,
        fontSize: theme.typography.pxToRem(12),
        [theme.breakpoints.up('lg')]: {
          paddingRight: 16,
        },

        '&__amount': {
          fontFamily: theme.typography.proxima.bold,
          lineHeight: '120%',
          paddingRight: 4,
          fontSize: theme.typography.pxToRem(12),
          letterSpacing: theme.typography.pxToRem(0),
          [theme.breakpoints.up('xl')]: {
            fontSize: theme.typography.pxToRem(16),
          },
        },
        '&__label': {
          textTransform: 'uppercase',
          letterSpacing: theme.typography.pxToRem(1.6),
          lineHeight: '120%',
        },

        '&:last-of-type': {
          padding: 0,
        },

        [theme.breakpoints.up('xl')]: {
          fontSize: theme.typography.pxToRem(16),
        },
      },

      [theme.breakpoints.only('xs')]: {
        ...theme.rccl.labelSmall,

        '&__values': {
          justifyContent: 'center',
        },
      },
      [theme.breakpoints.down('lg')]: {
        '& .timeUnit__label': {
          lineHeight: '24px',
        },
      },
      [theme.breakpoints.down('md')]: {
        flexDirection: 'row',
      },
    },

    [theme.breakpoints.up('sm')]: {
      '& .countDownContainer': {
        ...theme.rccl.labelMedium,
        '& .column': {
          maxWidth: 'fit-content',
        },
        '& .title': {
          textAlign: 'right',
        },
      },
    },
    [theme.breakpoints.only('xs')]: {
      '& .countDownContainer': {
        ...theme.rccl.labelSmall,

        '&__values': {
          justifyContent: 'center',
        },
      },
    },
  },

  courtesyHold: {
    background: theme.palette.white,
  },
});
